/**
 * ScrollContext is used for components that need to update based on visibility in the viewport.
 * For example, when setting up automatic loading of items based on scroll position, a possibly
 * deeply-nested component (like a load more button) needs to set up a onscroll event handler on
 * the closest scrolling container that could bring it into view.
 */
import React from "react";

export const ScrollContext = React.createContext<HTMLElement | null>(null);
ScrollContext.displayName = "ScrollContext";
